import React from 'react';
import './ChatView.css';
import { ChatWindow } from './ChatWindow';
import { Button } from '../../components/base/Button';
import { Text, TextForm } from '../../components/base';
export const ChatView = ({ title, messages, chatRecommendations, isLoading = false, shortcutButtons, disabled, initialText, handleSubmit, style, }) => {
    return (React.createElement("div", { className: "flex-column", style: {
            justifyContent: 'space-between',
            height: '100%',
            width: '100%',
        } },
        title && React.createElement(Text, { value: 'Flow Chat', className: "header2" }),
        React.createElement(ChatWindow, { isLoading: isLoading, messages: messages, recommendations: chatRecommendations, style: style }),
        React.createElement("div", { className: "flex-row" }, shortcutButtons &&
            shortcutButtons.map((button, index) => {
                return React.createElement(Button, { key: index, ...button });
            })),
        handleSubmit && React.createElement(TextForm, { disabled: disabled, initialText: initialText, handleSubmit: handleSubmit })));
};
